export enum PurchaseStatus {
    START = 'Start',
    SUCCESS = 'Success',
    FAIL = 'Fail',
    TEST = 'Test',
    ERROR = 'Error',
}
